import {
  buttonClickTrackingWithDynamicContexts,
  linkClickTrackingWithDynamicContexts,
} from '@angi/snowplow-js-common';


const SNOWPLOW_APP_ID = 'office-app';
const brandName = 'ANGI';

// Defines custom context entities for Snowplow button/link click tracking.
// When a button or link is clicked, Snowplow will attach this context to the event payload.
// The `entityPath` points to the Iglu schema registry path, and `properties`
// define which dynamic values to include.
const additionalButtonAndLinkContexts = [
  {
    entityPath: 'iglu:com.angi.entities/service_provider_attributes/jsonschema/1-0-0',
    properties: [
      { name: 'ads_service_provider_id', type: 'string' },
      { name: 'leads_service_provider_id', type: 'string' },
    ],
  },
];

export default function configureSnowplow(config) {
  const SNOWPLOW_COLLECTOR_URL = config.snowplowAngiCollectorUrl;
  const SNOWPLOW_POST_PATH = config.snowplowAngiPostPath;

  return {
    appId: SNOWPLOW_APP_ID,
    collectorUrl: SNOWPLOW_COLLECTOR_URL,
    trackerConfiguration: {
      discoverRootDomain: true,
      postPath: SNOWPLOW_POST_PATH,
    },
    pluginConfiguration: {
      defaultPluginConfigurationOverrides: {
        buttonClickTracking: buttonClickTrackingWithDynamicContexts(
          true,
          additionalButtonAndLinkContexts,
        ),
        linkClickTracking: linkClickTrackingWithDynamicContexts(
          true,
          additionalButtonAndLinkContexts,
        ),
      },
    },
    presetGlobalContexts: { brandName },
  };
}



// WEBPACK FOOTER //
// ./src/app/common/utils/analytics/snowplow/configureSnowplow.js